import { StatesDropdown } from '../../components/StatesDropdown'
import MarkerDetailsPopup from '../../components/MapSection/subComponent/MarkerDetailsPopup'
import ZoomControls from '../../components/MapSection/subComponent/ZoomControls'
import { UtilitiesMetrics2 } from '../../components/UtilitiesMetrics'
import { MapLegend } from '../../components/MapLegend'
import React, { FC } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { MapActions, MapSelector } from '../../store/Map'
import { WaterSystemsSelector } from '../../store/waterSystems'
import { MapRefProps } from './Main'

interface OverlayDetailProps {
  mapRefs: React.MutableRefObject<MapRefProps | null>
}

export const OverlayDesktop:FC<OverlayDetailProps> = ({mapRefs}) => {
  const dispatch = useDispatch()

  const waterSystemType = useSelector(WaterSystemsSelector.getSelectedWaterSystemType)
  const zoom = useSelector(MapSelector.getMapZoom)

  const handleMouseEnter = () => {
    dispatch(MapActions.setPopupDetail({timeout:null}))
  }
  const handleMouseLeave = () => {
    dispatch(MapActions.setPopupDetail({timeout:500}))
  }

  const zoomIn = async () => {
    return dispatch(MapActions.setMapZoom({zoom: zoom + 1}))
  }
  const zoomOut = () => {
    return dispatch(MapActions.setMapZoom({zoom:zoom-1}))
  }

  return (
    <>
      <StatesDropdown ContainerProps={{ sx:{position: 'absolute',
          top: { xs: '16px', sm: '24px', md: '30px' },
          left: { xs: '8px', sm: '10px' },
          zIndex: 10}}} />
      <MarkerDetailsPopup
        handleMouseEnter={handleMouseEnter}
        handleMouseLeave={handleMouseLeave}
        waterSystemType={waterSystemType}
      />
      <ZoomControls
        onZoomIn={zoomIn}
        onZoomOut={zoomOut}
      />
      <UtilitiesMetrics2 CardProps={{
        sx:{ position: 'absolute', bottom: '20px', right: '20px', zIndex: 3 }
      }} />
      <MapLegend CardProps={{
        sx:{ position: 'absolute', bottom: '20px', left: '20px', zIndex: 3 }
      }}  />
    </>
  )
}